module.exports = "<div id='ser-main'>\r\n    <div id='error-text'>\r\n      <span>{{ \"code\" | translate: \"ERR503\" }}</span>\r\n      <p>{{ \"name\" | translate: \"ERR503\" }}</p>\r\n      <p class='hmpg'><a href='#' class=\"back\" (click)=\"onLogoutClick()\">{{ \"button\" | translate: \"ERR503\" }}</a></p>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/screens/errors/503.component.html
// module id = 703
// module chunks = 63